import { createReducer } from "deox";

import { termDatesSuccess, termDatesError } from "./servicesStateActions";
import { TermDate } from "../../../types/types";

export interface TermDateState {
  termDatesByServiceId: TermDate[];
  isLoadingTermDates: boolean;
}

export const initialState: TermDateState = {
  termDatesByServiceId: [],
  isLoadingTermDates: false,
};

const termDatesReducer = createReducer(initialState, (handleAction) => [
  handleAction(termDatesSuccess, (state, action) => ({
    ...state,
    isLoadingTermDates: false,
    termDatesByServiceId: action.payload,
  })),
  handleAction(termDatesError, (state) => ({
    ...state,
    isLoadingTermDates: false,
    termDatesByServiceId: new Array<TermDate>(),
  })),
]);

export default termDatesReducer;
